import { AddMarketSchema } from '../components/Markets/AddMarketModal';
import { EditMarketSchema } from '../components/Markets/EditMarketModal';

import { api } from './api';

export const utilitiesApi = api.injectEndpoints({
  endpoints: (build) => ({
    getAdminUtilities: build.query<any[], Record<any, any>>({
      query: (queryParams) => ({
        url: `/admin/markets${
          queryParams &&
          '?' +
            new URLSearchParams({
              ...queryParams,
            }).toString()
        }`,
      }),
      transformResponse: (response: { data: any[]; total: number }) => response.data,
      providesTags: () => [{ type: 'AdminUtilities', id: 'LIST' }],
    }),
    getAdminUtilitiesPaginated: build.query<{ data: any[]; total: number }, Record<any, any>>({
      query: (queryParams) => ({
        url: `/admin/markets${
          queryParams &&
          '?' +
            new URLSearchParams({
              ...queryParams,
            }).toString()
        }`,
      }),
      providesTags: () => [{ type: 'AdminUtilities', id: 'LIST' }],
    }),
    getUtilities: build.query<any[], Record<any, any>>({
      query: (queryParams) => ({
        url: `/utilities${
          queryParams &&
          '?' +
            new URLSearchParams({
              ...queryParams,
            }).toString()
        }`,
      }),
      keepUnusedDataFor: 300,
      providesTags: () => [{ type: 'Utilities', id: 'LIST' }],
    }),
    getUtilitiesListFilters: build.query<any, Record<any, any>>({
      query: () => {
        return {
          url: `utilities/filters`,
        };
      },
    }),
    createUtility: build.mutation<any, { marketData: AddMarketSchema & { status: 'active' } }>({
      query: ({ marketData }) => ({ url: `/utilities`, method: 'POST', body: marketData }),
      invalidatesTags: () => [
        { type: 'Utilities', id: 'LIST' },
        { type: 'AdminUtilities', id: 'LIST' },
      ],
    }),
    updateUtility: build.mutation<any, { id: string; marketData: EditMarketSchema }>({
      query: ({ id, marketData }) => ({ url: `/utilities/${id}`, method: 'PATCH', body: marketData }),
      invalidatesTags: () => [
        { type: 'Utilities', id: 'LIST' },
        { type: 'AdminUtilities', id: 'LIST' },
      ],
    }),
  }),
});

export const {
  useGetAdminUtilitiesQuery,
  useGetAdminUtilitiesPaginatedQuery,
  useGetUtilitiesQuery,
  useGetUtilitiesListFiltersQuery,
  useLazyGetAdminUtilitiesQuery,
  useLazyGetAdminUtilitiesPaginatedQuery,
  useLazyGetUtilitiesQuery,
  useCreateUtilityMutation,
  useUpdateUtilityMutation,
} = utilitiesApi;
